import React, { useState } from 'react';
import { FormControl } from '@material-ui/core';
import { CustomTextField, CustomLabel,CustomButton }  from "@tracknme/material-ui";
import alertMessage from '../../services/alertMessage';
import AlertSnackbar from '../Snackbar/Snackbar';
import Recaptcha from 'react-google-invisible-recaptcha';
import Check from '@material-ui/icons/Check';
import '../../App.css';
import '../../menu.css';
import { UsersApi } from '../../services/Apis';


function UserPage() {

  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [errorEmail, setErrorEmail] = useState(false);
  const [confirmPassword,setConfirmPassword] = useState(null);
  const [errorPassword,setErrorPassword] = useState(false);
  const [validationPassword,setValidationPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [captchaResponse, setCaptchaResponse] = useState(null);
  const refRecaptcha = React.useRef(null)


  const handleChangePasswordValue = ({target}) => {
    const {value} = target;
    setPassword(value);

    if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
      setValidationPassword(true)
    }
  }

  const handleChangeConfirmPasswordValue = ({target}) => {
    const {value} = target;
    setConfirmPassword(value);

    if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
      setValidationPassword(true)
    }
  }

  const handleChangeNameValue = ({target}) => {
    const {value} = target;
    setName(value);
  }

  const handleChangeEmailValue = ({target}) => {
    const {value} = target;
    setEmail(value);
  }

const checkPasswordLength = () => {

    if(password && password.length > 7){
      setValidationPassword(true)
      setErrorPassword(false)
    }else{
      
      alertMessage.showErrorMessage("A senha precisa conter no mínimo 8 caracteres!");
      setValidationPassword(false)
      setErrorPassword(true)
    }
  
  }

const checkPassword = () => {

    if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
      refRecaptcha.current.execute();
      setValidationPassword(true)
      setErrorPassword(false)
    }else{
      setValidationPassword(false)
      setErrorPassword(true)
     
      if(password && password.length < 8){
        alertMessage.showErrorMessage("A senha precisa conter no mínimo 8 caracteres!");
      }else{
        alertMessage.showErrorMessage("As senhas precisam ser iguais!");
      }

      
    }

  }



function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

const checkEmail = () => {

    if(validateEmail(email)){
     
      UsersApi.checkLogin(email).then(response => {

        if(response.data === 0){
         setErrorEmail(false)

        }else{
          console.log("E-mail Error")
          alertMessage.showErrorMessage("Esse e-mail já está em uso na plataforma!");
          setErrorEmail(true)
        }
       
        return
      }).catch(error => {
        console.log("error E-mail Error",error)
          setErrorEmail(true)
        return
      })
    }else{
      setErrorEmail(true)
      alertMessage.showErrorMessage("E-mail inválido!")
    }

}
 

const changeButtonValue = async() => {

    if (!validateEmail(email)) {
        alertMessage.showErrorMessage("E-mail inválido!")
        setErrorEmail(true)
        return
    }

    setErrorEmail(false)

    setIsDisabled(true)

    let body = {
        "brand": 0,
        "login": email,
        "name": name,
        "password": password,
        "captchaResponse": captchaResponse
    }

    const query = new URLSearchParams(window.location.search);
    const token = query.get('t')
   
    try {
       await UsersApi.userRegister(body,token);
        setTimeout(() => {
            if (!process.env.NODE_ENV === 'production') {
              window.location.href = 'https://dev.tracknme.com.br/monitoring/login'
            } else {
              window.location.href = 'https://www.tracknme.com.br/monitoring/login'
            }
          }, 6000);
        alertMessage.showSuccessMessage('Registro criado com sucesso!. Você será redirecionado para a página da TracknMe, Obrigado!')
    } catch(e) {
      showErrorRequest(e)
    }

}

const showErrorRequest = ({ response }) => {
  if (response) {
      if (response.status === 400) alertMessage.showErrorMessage(response.data.message);
      if (response.status === 502) alertMessage.showErrorMessage('Serviço indisponível, tente novamente em alguns segundos...');
      if (response.status === 500) alertMessage.showErrorMessage(response.data.message);
  }
}

  return (
    
        <div>
             <div className="titleStep1">
                <CustomLabel id="standard-basic-data-picker" label="Informe seu e-mail e uma senha para realizar o cadastro!" color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'bold', color:"#4D39E9"}} />  
            </div>
            <div className="form_top">
                    <div className="conteudoStep1">
                      <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                        <CustomTextField
                              label="Nome Completo:"
                              variant="filled"
                              value={name}
                              disabled={isDisabled}
                              name="name_1"
                              onChange={handleChangeNameValue}
                              placeholder="Insira seu nome"
                              inputProps={{
                                autoComplete: 'new-password',
                                form: {
                                  autoComplete: 'off',
                                }
                              }}
                              style={{
                              width: '30vw'
                          }}/>
                      </FormControl>
                      <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                         <CustomTextField
                              id="email_3"
                              name="email_3"
                              label="Insira o e-mail que será usado no login:"
                              variant="filled"
                              disabled={!name}
                              value={email}
                              onBlur={() => checkEmail()}  
                              onFocus={() => setErrorEmail(true)}
                              onKeyPress={event => {if (event.key === 'Enter') {  checkEmail() }}}
                              onChange={handleChangeEmailValue}
                               placeholder="Insira o e-mail que será usado no login"
                              error={errorEmail}
                              type="text"
                              inputProps={{
                                
                                autoComplete: 'new-password',
                                form: {
                                  autoComplete: 'off',
                                }
                              }}
                              style={{
                              width: '30vw'
                              }}/> 
                             
                      </FormControl>
                  </div>
            </div>
            <div className="form_bottom">
                    <div className="conteudo_bottom">
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField  
                        label="Senha:" 
                        value={password} 
                        disabled={!name}
                        onBlur={() => checkPasswordLength()} 
                        name="pass_1"  
                        onChange={handleChangePasswordValue} 
                        variant="filled" 
                        type="password" 
                        placeholder="Insira uma senha de até 10 caracteres" 
                        style={{width:'30vw'}} 
                        error={errorPassword}
                    />
                  </FormControl>
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                       <CustomTextField  
                            label="Confirmar Senha:" 
                            disabled={!name}
                            value={confirmPassword} 
                            name="pass_2"  
                            onChange={handleChangeConfirmPasswordValue} 
                            onBlur={() => checkPassword()}    
                            onKeyPress={event => {if (event.key === 'Enter') {  checkPassword() }}} 
                            type="password" variant="filled" placeholder="Confirme a sua senha" 
                            style={{width:'30vw'}} 
                            error={errorPassword}/> 

                  
                  </FormControl>
                  </div>
            </div>
            <div className="form_bottom">
                    <div className="conteudo_bottom">
                    <div className="button">
                            <CustomButton
                                disabled={(name  && email && password && validationPassword && confirmPassword && !errorEmail &&!errorPassword)
                                ? false
                                : true}
                                onClick={changeButtonValue}
                                variant="contained"
                                color="secondary"
                                label="Cadastrar"
                                style={{width: '62vw',height: '45px',marginTop:10 }}
                                endIcon={< Check />}/> 
                        </div>
                  </div>

            </div> 

            <div className="fixedMessage">
                <AlertSnackbar/>
            </div>

            <Recaptcha
              ref={refRecaptcha}
              sitekey={"6Lf3P6MUAAAAAEOBwDRiVjoB6whiH4UEstdvqQ-5"}
              onResolved={ (token) => setCaptchaResponse(token) } 
            />

        </div>
  );
}

export default UserPage;

